import React from "react";
import LoadMask from "Utils/LoadMask/LoadMask";
import CardEmpty from "Utils/Cards/CardEmpty";
import { AlcanceRegistrado } from "./AlcanceRegistrado";
import { EncabezadoCierre } from "./EncabezadoCierre";
import { MensajeReporteSinDatos } from "../../../components/MensajeReporteSinDatos";
import { SeccionDiferenciasRegistradas } from "./SeccionDiferenciasRegistradas";
import { SeccionesComparativo } from "../../../components/SeccionesComparativo";
import { useDetalleCierreMensualProduccion } from "../hooks/useDetalleCierreMensualProduccion";

// Un cierre mensual ya registrado: el alcance y las cifras que quedaron
// congeladas en él, junto con los dos reportes de los que salieron, que se
// consultan en el momento
export const DetalleCierreContent = ({ cierreId, regresar }) => {
    const hook = useDetalleCierreMensualProduccion(cierreId);

    return (
        <CardEmpty noShadow>
            <LoadMask loading={hook.cargando} blur>
                <EncabezadoCierre hook={hook} regresar={regresar} />

                <AlcanceRegistrado cierre={hook.cierre} />

                {hook.comparativo && (
                    <SeccionesComparativo
                        comparativo={hook.comparativo}
                        pendientesTraslados={null}
                        descripcionComparativo="Cifras registradas al cerrar el periodo."
                    >
                        <SeccionDiferenciasRegistradas hook={hook} />
                    </SeccionesComparativo>
                )}

                {hook.mensajeError && (
                    <MensajeReporteSinDatos mensajeError={hook.mensajeError} />
                )}
            </LoadMask>
        </CardEmpty>
    );
};
